import { Icon } from '@shared/ui/icon';
import { Tooltip } from '@shared/ui/tooltip';

import { FUND_METRIC_CARD_TEXT } from './fund-metric-card.text';

export interface FundMetricHelpProps {
  /** 지표 제목(버튼 이름에 쓴다) */
  title: string;
  /** 도움말 줄 */
  help: readonly string[];
}

/** 지표 제목 옆 물음표(12). 올리거나 포커스하면 아래쪽에 설명 말풍선(light) */
export function FundMetricHelp({ title, help }: FundMetricHelpProps) {
  return (
    <Tooltip
      placement="bottom"
      content={help.map((line) => (
        <span key={line}>{line}</span>
      ))}
    >
      <button
        type="button"
        aria-label={`${title} ${FUND_METRIC_CARD_TEXT.helpSuffix}`}
        className="inline-flex cursor-help rounded-full text-fg-muted focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus"
      >
        <Icon name="help-circle" size="xs" />
      </button>
    </Tooltip>
  );
}
